<template>
  <div class="form-registro">
    <main class="container registro p-5">
        <img class="mb-4 mx-auto d-block" src="img/logo-vertical.png" alt="" width="250">
        <h1 class="titulo-r text-center">Ingrese el código <br>de verificación</h1>
        <p class="text-center texto-r">Se envió un código a tu correo electrónico</p>
        <form @submit.prevent="submit" class="d-flex justify-content-center p-2">
                <div class="col-sm-6">
                    <div class="row d-flex justify-content-center p-2">
                        <div class="col-sm-2">
                        <input type="text" class="form-control" id="c1" v-model="campo.c1" maxlength="1" @keyup="focusNext" >
                        </div>
                        <div class="col-sm-2">
                            <input type="text" class="form-control" id="c2" v-model="campo.c2" maxlength="1" @keyup="focusNext" >
                        </div>
                        <div class="col-sm-2">
                            <input type="text" class="form-control" id="c3" v-model="campo.c3" maxlength="1" @keyup="focusNext" >
                        </div>
                        <div class="col-sm-2">
                            <input type="text" class="form-control" id="c4" v-model="campo.c4" maxlength="1">
                        </div>
                    </div>


                  <p class="text-center m-t"><a @click="reenviarCorreo">¿No te llegó el código?</a></p>
                  <button class="w-100 btn btn-lg btn btn-registro m-t" type="submit">Recuperar contraseña </button>
                </div> 
        </form>
    </main>
</div>
</template>

<script>

import helpers from '@/services/helpers'
import auth from '@/services/auth'

export default {
  name: "Login",
  data() {
    return {
      validateForm: {
        Correo:  localStorage.getItem("mailRec"),
        Codigo: "",
      },
      recoverForm: {
        Correo: localStorage.getItem("mailRec"),
      },
      campo:{
        c1:"",
        c2:"",
        c3:"",
        c4:"",
      },
      validado : false,
      deshabilitado: true,
      
    };
  },

  mounted() {
    helpers.habilitarBoton(this);
  },
  methods: {
    async submit(e) {
      
      let _this = this;
      _this.validateForm.Codigo=_this.campo.c1+_this.campo.c2+_this.campo.c3+_this.campo.c4;
      //helpers.deshabilitarBoton(this);
     
      if (
        _this.validateForm.Codigo.length < 4
      ) {
        toastr["error"]("Ingrese un codigo válido");
        return;
      }
      //login
      if (await auth.validate(this)){
        //console.log("VERIFICACIÓN CORRECTA");
      }
      else{
        //console.log("ERROR AL VERIFICAR");
      }
      helpers.habilitarBoton(this, 4);
    },
    focusNext($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if((keyCode > 47 && keyCode < 58)||(keyCode>64 && keyCode<91)||(keyCode>95&&keyCode<123)){
        let elem=$event.target;        
      const currentIndex = Array.from(elem.form.elements).indexOf(elem);
      elem.form.elements.item(
        currentIndex < elem.form.elements.length - 1 ?
        currentIndex + 1 :
        0
      ).focus();
      }
    },
    async reenviarCorreo(){
       if (await auth.recover(this)){
      }
      else{
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Verificacion.vue